
import { defineComponent, PropType } from 'vue';
import { FavoriteView } from '../services/swagger/index.defs';
import Removable from '@/common/components/Removable.vue';

export default defineComponent({
  components: {
    Removable,
  },

  props: {
    favoriteViews: Array as PropType<FavoriteView[]>,
  },

  emits: ['click-item', 'remove-item'],
});
